<template>
  <BaseLayout :title="title">
    <template #actions>
      <InlineButton @click="onCreate" pill shadow>
        <span class="text-uppercase">{{ $t('text.newButton') }}</span>
      </InlineButton>
    </template>

    <DeliveryTypeTable
      :list="deliveryTypeList"
      :meta="deliveryTypeListMeta"
      :current-page="currentPage"
      :is-loading="isLoading"
      @edit="onEdit"
      @onChangePage="onChangePage"
    />

    <DeliveryTypeAddEditModal
      :form-data="dataToEdit"
      :modal-id="editModalId"
      @onHidden="emptyingDataToEdit"
      @onRemove="onConfirmDelete"
    />

    <ConfirmDialog :id="deleteModalId" @ok="remove" />
  </BaseLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import { DELIVERY_TYPE_LIST_REQUEST, DELIVERY_TYPE_DELETE } from '@/store/actions/deliveryType';
import meMixin from '@/mixins/meMixin';
import BaseLayout from '@/components/ui/BaseLayout';
import InlineButton from '@/components/ui/button/InlineButton';
import DeliveryTypeTable from '@/components/manage/deliveryTypes/DeliveryTypeTable';
import DeliveryTypeAddEditModal from '@/components/manage/deliveryTypes/DeliveryTypeAddEditModal';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default {
  mixins: [meMixin],

  props: {
    title: String,
  },

  data() {
    return {
      currentPage: 1,
      dataIdToEdit: null,
      dataIdToRemove: null,
      editModalId: 'manage-form-modal',
      deleteModalId: 'manage-delete-modal',
    };
  },

  computed: {
    ...mapGetters([
      'deliveryTypeList',
      'deliveryTypeListMeta',
      'deliveryTypeListStatus',
      'getDeliveryTypeById',
      'deliveryTypeStatus',
    ]),
    dataToEdit() {
      return this.dataIdToEdit ? this.getDeliveryTypeById(this.dataIdToEdit) : null;
    },
    isLoading() {
      return this.deliveryTypeListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const payload = {
        limit: 10,
        page: this.currentPage,
        filter: {},
      };
      await this.$store.dispatch(DELIVERY_TYPE_LIST_REQUEST, payload);
    },
    emptyingDataToEdit() {
      this.dataIdToEdit = null;
    },
    onCreate() {
      this.emptyingDataToEdit();
      this.openModal();
    },
    onEdit(id) {
      this.dataIdToEdit = id;
      this.openModal();
    },
    openModal() {
      this.$bvModal.show(this.editModalId);
    },
    onChangePage(page) {
      this.currentPage = page;
      this.fetchData();
    },
    onConfirmDelete(id) {
      this.dataIdToRemove = id;
      this.$bvModal.show(this.deleteModalId);
    },
    async remove() {
      await this.$store.dispatch(DELIVERY_TYPE_DELETE, this.dataIdToRemove);
      if (this.deliveryTypeStatus === 'deleted') {
        this.emptyingDataToEdit();
        this.$bvModal.hide(this.editModalId);
        this.dataIdToRemove = null;
      }
    },
  },

  components: {
    BaseLayout,
    InlineButton,
    DeliveryTypeTable,
    DeliveryTypeAddEditModal,
    ConfirmDialog,
  },
};
</script>
